import { render, staticRenderFns } from "./NsHeaderLoyaltyRewards.vue?vue&type=template&id=2e88bb7e&"
import script from "./NsHeaderLoyaltyRewards.vue?vue&type=script&lang=js&"
export * from "./NsHeaderLoyaltyRewards.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderLoyaltyRewards.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports